module.exports = __webpack_public_path__ + "img/WhiteCarnationfade.9c4ed6a3.png";